import React, { ElementType, ReactElement } from "react";
import styles from "./bannerCta.module.scss";
import Link from "next/link";
import { ArrowRight } from "@untitled-ui/icons-react";
import { trackEventNext } from "@kunduz/utility-analytics";

export const PlanDetailBannerCta = (props: Props): ReactElement => {
  const ButtonIcon = props.buttonIcon;

  function handleOnCtaClick() {
    trackEventNext({
      event: "CTA Banner Clicked",
      title: props.title,
      link: props.buttonUrl,
    });
  }

  return (
    <div className={styles.wrapper} style={{ backgroundColor: props.bgColor }}>
      <img className={styles.icon} loading="lazy" src={props.imageUrl} alt="" />
      <div className={styles.content}>
        <div className={styles.textAndSupport}>
          <p className={styles.title}>{props.title}</p>
          {props.description && (
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{ __html: props.description }}
            ></div>
          )}
        </div>
        {props.buttonUrl && (
          <Link
            href={props.buttonUrl}
            className={styles.button}
            target={props.buttonTarget}
            onClick={(e) => handleOnCtaClick()}
          >
            {ButtonIcon && <ButtonIcon />}
            {props.buttonLabel}
            <ArrowRight />
          </Link>
        )}
      </div>
    </div>
  );
};

interface Props {
  bgColor?: string;
  imageUrl?: string;
  title?: string;
  description?: string;
  buttonLabel?: string;
  buttonIcon?: ElementType;
  buttonUrl?: string;
  buttonTarget?: string;
}
